import { render } from "./BasketIndustryModal.vue?vue&type=template&id=4eda8c7a"
import script from "./BasketIndustryModal.vue?vue&type=script&lang=js"
export * from "./BasketIndustryModal.vue?vue&type=script&lang=js"

import "./BasketIndustryModal.vue?vue&type=style&index=0&id=4eda8c7a&lang=less"

import exportComponent from "/builds/sun-chemical/color-materials/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__